import { Link } from 'react-router-dom'
import type { EventHoneybookDto } from '@lib/dto/event.dto'
import { HONEYBOOK_EVENT_PROBLEM_COPY } from '@lib/enums/honeybook-event-problem.enum'
import { Callout } from '@/components/ui/callout'

/**
 * What keeps an event HoneyBook manages from following its project, shown at
 * the top of the event (docs/honeybook.plan.md, 4.7): a lane another event
 * holds, or a problem with its project.
 */
export function HoneyBookEventNotices({ honeybook }: { honeybook: EventHoneybookDto }) {
  return (
    <>
      {honeybook.clashWith === null ? null : (
        <Callout tone="attention" title="Two events on one lane">
          HoneyBook put this event on a day and track{' '}
          <Link to={`/events/${honeybook.clashWith.id}`} className="font-medium text-ink underline underline-offset-2">
            {honeybook.clashWith.name}
          </Link>{' '}
          already has. Move one of them.
        </Callout>
      )}
      {honeybook.problem === null ? null : (
        <Callout tone="attention" title="This event isn’t following HoneyBook">
          {HONEYBOOK_EVENT_PROBLEM_COPY[honeybook.problem]}
        </Callout>
      )}
    </>
  )
}
